import {
  EMPRESAS_HOME,
  EMPRESAS_ENERGIA,
  EMPRESAS_CONSULTORIO,
  EMPRESAS_AUSENTISMO,
  EMPRESAS_CAPACITACION,
  EMPRESAS_SALVAMENTO,
  EMPRESAS_EVENTOS,
  EMPRESAS_TRASLADOS,
  EMPRESAS_LABORAL,
  EMPRESAS_CUIDADOS,
  EMPRESAS_AREA_PROTEGIDA,
  FAMILIAS_HOME,
  INFO_UTIL,
} from "../routes/paths";

const item = (key, label, to, last = false) => ({ key, label, to, last });

/**
 * Nav sección Menu (Figma).
 * Con submenú solo los que tienen panel abierto definido:
 * Comercio y empresas, Institucional, Novedades.
 */
const menuItems = [
  {
    key: "familias",
    label: "Familias",
    static: false,
    to: FAMILIAS_HOME,
  },
  {
    key: "empresas",
    label: "Comercio y empresas",
    static: true,
    elemens: [
      item("emp-home", "Servicios", EMPRESAS_HOME),
      item("emp-ausentismo", "Control de ausentismo", EMPRESAS_AUSENTISMO),
      item("emp-area", "Área protegida", EMPRESAS_AREA_PROTEGIDA),
      item("emp-emergencias", "Emergencias y urgencias médicas", EMPRESAS_SALVAMENTO),
      item("emp-cuidados", "Cuidados domiciliarios", EMPRESAS_CUIDADOS),
      item("emp-consultorio", "Consultorios in company", EMPRESAS_CONSULTORIO),
      item("emp-laboral", "Medicina Laboral", EMPRESAS_LABORAL),
      item("emp-eventos", "Cobertura de Eventos", EMPRESAS_EVENTOS),
      item("emp-cursos", "Cursos de capacitación", EMPRESAS_CAPACITACION),
      item("emp-aereos", "Traslados aéreos", EMPRESAS_TRASLADOS),
      item("emp-traslados", "Traslados", EMPRESAS_TRASLADOS),
      item("emp-energia", "ECCO petroleo, gas y minería", EMPRESAS_ENERGIA, true),
    ],
  },
  {
    key: "institucional",
    label: "Institucional",
    static: true,
    elemens: [
      item("inst-ecco", "Sobre ECCO", "/nuestra-empresa"),
      item("inst-bases", "Sucursales y Bases operativa (corpo)", "/sucursales", true),
    ],
  },
  {
    key: "novedades",
    label: "Novedades",
    static: false,
    to: "/notas",
  },
  {
    key: "info",
    label: "Información útil",
    static: false,
    to: INFO_UTIL,
  },
  {
    key: "asociate-hoy",
    label: "Asociate hoy",
    static: false,
    to: "/productos/consulta",
    cta: true,
  },
];

export default menuItems;
